import { useEffect, useState } from 'react'
import logoLight from '../assets/logo-light.svg'
import logo from '../assets/logo.svg'
import useIsMobile from '../hooks/isMobile'
import { api } from '../env'
import { debounce } from '../utils/timing'
import ThemeToggle from './ThemeToggle'

export function AdminHeader() {
    const routes = [
        {path: '/admin/companies', label: 'Companies'},
        {path: '/admin/questionnaires', label: 'Questionnaires'},
        {path: '/admin/tracks', label: 'Tracks'},
        {path: '/admin/activities', label: 'Activities'},
        {path: '/admin/materials', label: 'Resources & Sparks'},
        {path: '/admin/failed-logins', label: 'Failed Logins'},
        {path: '/admin/account', label: 'Account'}
    ]
    return(<Header routes={routes} isDark={true}/>)
}

export function CompanyManagerHeader() {
    const routes = [
        {path: '/manager/programs', label: 'Programs'},
        {path: '/manager/tracks', label: 'Tracks'},
        {path: '/manager/questionnaires', label: 'Questionnaires'},
        {path: '/manager/sparks', label: 'Sparks'},
        {path: '/manager/account', label: 'Account'}
    ]
    return(<Header routes={routes} isDark={true}/>)
}

export function ParticipantHeader() {
    const routes = [
        {path: '/participant/invites', label: 'Dashboard'},
        {path: '/participant/account', label: 'Account'}
    ]
    return(<Header routes={routes} isDark={false}/>)
}

export function DemoHeader() {
    const routes = []
    return(<Header routes={routes} isDark={false}/>)
}

export function CenteredHeader({}) {

    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        // NOTE: ChatGPT generated code for dynamically changing header color...
        const computeCompositeColor = () => {
            const x = window.innerWidth / 2
            const y = 20
            const elements = document.elementsFromPoint(x, y)

            let composite = [255, 255, 255, 0]

            for (let i = elements.length - 1; i >= 0; i--) {
                const el = elements[i]
                const style = getComputedStyle(el)
                let color = style.backgroundColor
                if (!color || color === "transparent") continue

                const rgba = color.match(/\d+(\.\d+)?/g)?.map(Number)
                if (!rgba) continue

                const [r, g, b, a = 1] = rgba
                const opacity = parseFloat(style.opacity) || 1
                const alpha = a * opacity

                const outAlpha = alpha + composite[3] * (1 - alpha)
                composite = [
                    Math.round((r * alpha + composite[0] * composite[3] * (1 - alpha)) / outAlpha),
                    Math.round((g * alpha + composite[1] * composite[3] * (1 - alpha)) / outAlpha),
                    Math.round((b * alpha + composite[2] * composite[3] * (1 - alpha)) / outAlpha),
                    outAlpha
                ]
            }

            const [r, g, b] = composite
            const brightness = (r * 299 + g * 587 + b * 114) / 1000
            setIsDark(brightness < 128)
        }

        computeCompositeColor()

        const observer = new MutationObserver((mutations) => {
            for (const m of mutations) {
                for (const node of m.addedNodes) {
                    if (node.nodeType === 1 && node.matches(".bg-target")) computeCompositeColor()
                }
                for (const node of m.removedNodes) {
                    if (node.nodeType === 1 && node.matches(".bg-target")) computeCompositeColor()
                }
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })
        const debouncedScroll = debounce(() => {
            computeCompositeColor()
        }, 7)

        const scrollContainer = document.querySelector(".silent-scroll") || window
        scrollContainer.addEventListener("scroll", debouncedScroll)
        window.addEventListener("resize", debouncedScroll)
        return () => {
            scrollContainer.removeEventListener("scroll", debouncedScroll)
            window.removeEventListener("resize", debouncedScroll)
            observer.disconnect()
        }
    }, []);

    return(<header className='padding grid blur-behind w-100' style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
        <div></div>
        <div className='flex justify-center'>
            <img src={logoLight} className='hi-spacer-xs' style={{height: '44px'}}></img>
        </div>
        <div className='flex justify-end center'>
            <ThemeToggle className="outline hi-spacer-xs"/>
            <button className="outline hi-spacer-xxs" onClick={handleLogout}>Logout</button>
        </div>
    </header>)
}

export function Header({routes, isDark}) {

    const isMobile = useIsMobile()
    const [isOpen, setIsOpen] = useState(false)
    useEffect(() => { if(!isMobile) setIsOpen(false) }, [isMobile])
    const handleOpen = () => setIsOpen(!isOpen)

    return(
        <>
            <div className="w-100 padding-m flex space-between gap-xs wrap center">
                <div className='flex center gap-s'>
                    {isMobile && <button className={`icon outline ${isDark ? 'inverted' : ''}`} onClick={handleOpen}><span className='material-symbols-outlined'>menu</span></button>}
                    <img src={isDark ? logoLight : logo} className="h-spacer-s" style={{height: '36px'}}></img>
                </div>
                <div className='flex center gap-xs'>
                    {!isMobile && <> {routes.map(route => <button className={`text ${isDark ? 'inverted' : ''} ${window.location.pathname.startsWith(route.path) ? 'selected' : ''}`} onClick={() => { window.location.href = route.path }}>{route.label}</button>)} </>}
                    <ThemeToggle className={`outline hi-spacer-xs ${isDark ? 'inverted' : ''}`}/>
                    <button className={`outline hi-spacer-xxs ${isDark ? 'inverted' : ''}`} onClick={handleLogout}>Logout</button>
                </div>
            </div>
            {isOpen && <div className='standard-padding-sm w-100 absolute showing highest-layer' style={{background: 'rgb(var(--primary-dark))'}}>
                {routes.map(route => <button className={`text inverted w-100 ${window.location.pathname == route.path ? 'selected' : ''}`} onClick={() => { window.location.href = route.path }}>{route.label}</button>)}
            </div>}
        </>
    )
}

export const handleLogout = () => { 
    api.post('/auth/logout')
        .then(res => { 
            console.log(res)
            window.location.href = '/' 
        })
        .catch(err => { window.location.href = '/' })
}